export default __webpack_public_path__ + "static/media/prott.e5d99cf0.svg";